<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-search h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all"
        aria-hidden="true"
    >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
    </svg>
</template>

<script>
export default {
    name: 'SearchIcon',
};
</script>

<style scoped>
svg {
    width: 18px;
    height: 18px;
    margin: auto;
}
</style>
